import { ColDef } from "ag-grid-community";

/**
 * Boolean column type for the ag-grid.
 */
export const BooleanColumn: ColDef = {
  filter: "agSetColumnFilter",
  floatingFilter: true,
  filterParams: {
    valueFormatter: (params) => {
      if (params.value) {
        return "Wel";
      }

      return "Niet";
    },
    defaultToNothingSelected: true,
    suppressSelectAll: true,
    suppressMiniFilter: true,
    suppressSorting: true,
    values: [true, false]
  },
  cellRenderer: "AppDataGridBooleanCellRenderer"
};
